module.exports = __webpack_public_path__ + "img/point.bf9dfd2c.svg";